import { render, staticRenderFns } from "./LeyendaColorEventos.vue?vue&type=template&id=4c0664a0&scoped=true"
var script = {}
import style0 from "./LeyendaColorEventos.vue?vue&type=style&index=0&id=4c0664a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0664a0",
  null
  
)

export default component.exports